<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>基础信息</h3>
                <p></p>
            </div>
            <div class="info-main">      
                <div class="input-box">
                    <p>论文成果：</p>
                    <a-select class="input" allowClear v-model="info.paperTypeCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in lwcgArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>作品分类：</p>
                    <a-select 
                        class="input" 
                        show-search
                        :filter-option="filterOption"
                        @search="value=>{if(value!='')info.classCode=value}"
                        allowClear 
                        v-model="info.classCode" 
                        :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in zpflArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>语言：</p>
                    <a-select 
                        class="input" 
                        show-search
                        :filter-option="filterOption"
                        @search="value=>{if(value!='')info.languageCode=value}"
                        allowClear 
                        v-model="info.languageCode" 
                        :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in lwyyArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p><span>*</span>标题：</p>
                    <a-input class="input" v-model="info.title" :disabled="type=='look'" allowClear />
                </div>
                <div class="input-box input-box-big">
                    <p>外文标题：</p>
                    <a-input class="input" v-model="info.foreignTitle" :disabled="type=='look'" allowClear />
                    <span class="input-tips">*“标题”内容为英文时,不必重复</span>
                </div>
            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <a-button type="primary" icon="plus" @click="showAuthor('添加作者','',-1)" v-if="type!='look'">新增</a-button>
                <h3>论文作者</h3>
                <p></p>
            </div>
            <a-table 
                :columns="authorColumns" 
                :data-source="info.authorList" 
                :pagination="false"
                bordered>
                <template slot="departmentCode" slot-scope="text,record">
                    <a-select class="show-input" allowClear v-model="record.departmentCode">
                        <a-select-option v-for="(item,index) in xyArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </template>
                <template slot="isCorrespond" slot-scope="text">{{text?'是':'否'}}</template>
                <template slot="memberType" slot-scope="text">{{text==1?'本机构成员':'非本机构成员'}}</template>
                <template slot="id" slot-scope="text,record">
                    <a class="action-btn" @click="showAuthor('修改作者',record,1)">编辑</a>
                    <a-divider type="vertical"/>
                    <a class="action-btn" @click="info.authorList.splice(info.authorList.indexOf(record),1)">删除</a>
                </template>
            </a-table>
            <p class="table-tips">*按序逐一添加作者,不得遗漏</p>
        </div>
        <div class="info-box" v-if="info.paperTypeCode=='QKLW'">
            <div class="info-title">
                <h3>出版信息</h3>
                <p></p>
            </div>
            <div class="info-main">      
                <div class="input-box">
                    <p><span>*</span>期刊名称：</p>
                    <a-input class="input" v-model="info.journalName" :disabled="type=='look'" allowClear />
                    <span class="input-tips">*填写期刊全称，如有标点用半角字符; 不可加书名号</span>
                </div>
                <div class="input-box">
                    <p><span>*</span>ISSN：</p>
                    <a-input class="input" v-model="info.issn" :disabled="type=='look'" allowClear />
                    <span class="input-tips">共9位，如1234-5678；如无ISSN则填写“无”。</span>
                </div>
                <div class="input-box">
                    <p><span>*</span>出版年：</p>
                     <a-date-picker
                        class="input time-ac"
                        mode="year"
                        v-model="info.publicationYear"
                        :open="dataopen"
                        format="YYYY年"
                        :allowClear="false"
                        @openChange="openChangeYear"
                        @panelChange="panelChangeYear"
                        :disabled="type=='look'"
                    />
                </div>
                <div class="input-box">
                    <p>出版地：</p>
                    <a-input class="input" v-model="info.publishPlace" :disabled="type=='look'" allowClear />
                </div>
                <div class="input-box">
                    <p>卷：</p>
                    <a-input class="input" v-model="info.publishVolume" :disabled="type=='look'" allowClear />
                    <span class="input-tips">*有则必填，便于系统正确匹配</span>
                </div>
                <div class="input-box">
                    <p>期：</p>
                    <a-input class="input" v-model="info.publishStage" :disabled="type=='look'" allowClear />
                    <span class="input-tips">*有则必填，便于系统正确匹配</span>
                </div>
                <div class="input-box input-box-big">
                    <p>页码范围：</p>
                    <a-input class="input" v-model="info.publishPage" :disabled="type=='look'" allowClear />
                    <span class="input-tips">*不连续页码用逗号分隔,如：72-85,100</span>
                </div>
                <div class="input-box input-box-big">
                    <p>属名机构：</p>
                    <a-textarea class="input" :rows="3" v-model="info.signatureAgency" :disabled="type=='look'" allowClear/>
                    <span class="input-tips">*论文中所有的作者机构信息</span>
                </div>
            </div>
        </div>
        <div class="info-box" v-if="info.paperTypeCode=='HYLW'">
            <div class="info-title">
                <h3>出版信息</h3>
                <p></p>
            </div>
            <div class="info-main">      
                <div class="input-box">
                    <p><span>*</span>会议论文集/期刊名称：</p>
                    <a-input class="input" v-model="info.journalName" :disabled="type=='look'" allowClear />
                    <span class="input-tips">*填写全称，如有标点用半角字符; 不可加书名号</span>
                </div>
                <div class="input-box">
                    <p><span>*</span>会议地点：</p>
                    <a-input class="input" v-model="info.conferencePlace" :disabled="type=='look'" allowClear />
                </div>
                <div class="input-box">
                    <p>会议开始日期：</p>
                    <a-date-picker 
                        class="input" 
                        allowClear
                        v-model="info.conferenceStartDate" 
                        :disabled="type=='look'" 
                        @change="(date,dataStr)=>{info.conferenceStartDate=dataStr}" />
                </div>
                <div class="input-box">
                    <p>会议结束日期：</p>
                    <a-date-picker 
                        class="input" 
                        allowClear
                        v-model="info.conferenceEndDate" 
                        :disabled="type=='look'" 
                        @change="(date,dataStr)=>{info.conferenceEndDate=dataStr}" />
                </div>
                <div class="input-box input-box-big">
                    <p>主办单位：</p>
                    <a-textarea class="input" :rows="3" v-model="info.conferenceOrganizer" :disabled="type=='look'" allowClear/>
                </div>
                <div class="input-box">
                    <p><span>*</span>会议名称：</p>
                    <a-input class="input" v-model="info.conferenceName" :disabled="type=='look'" allowClear />
                    <span class="input-tips">*填写全称，如有标点用半角字符</span>
                </div>
                <div class="input-box">
                    <p>ISSN/ISBN：</p>
                    <a-input class="input" v-model="info.issn" :disabled="type=='look'" allowClear />
                </div>
                <div class="input-box">
                    <p><span>*</span>出版年：</p>
                     <a-date-picker
                        class="input"
                        mode="year"
                        v-model="info.publicationYear"
                        :open="dataopen"
                        format="YYYY年"
                        :allowClear="false"
                        @openChange="openChangeYear"
                        @panelChange="panelChangeYear"
                        :disabled="type=='look'"
                    />
                </div>
                <div class="input-box">
                    <p>出版地：</p>
                    <a-input class="input" v-model="info.publishPlace" :disabled="type=='look'" allowClear />
                </div>
                <div class="input-box">
                    <p>卷：</p>
                    <a-input class="input" v-model="info.publishVolume" :disabled="type=='look'" allowClear />
                </div>
                <div class="input-box">
                    <p>期：</p>
                    <a-input class="input" v-model="info.publishStage" :disabled="type=='look'" allowClear />
                </div>
                <div class="input-box">
                    <p><span>*</span>页码范围：</p>
                    <a-input class="input" v-model="info.publishPage" :disabled="type=='look'" allowClear />
                    <span class="input-tips">*不连续页码用逗号分隔,如：72-85,100</span>
                </div>
                <div class="input-box">
                    <p>重要成果：</p>
                    <a-select mode="tags" class="input" allowClear v-model="majorAchievement" :disabled="type=='look'">
                        <a-select-option key="ESI高被引">ESI高被引</a-select-option>
                        <a-select-option key="ESI热点">ESI热点</a-select-option>
                        <a-select-option key="重要期刊">重要期刊</a-select-option>
                    </a-select>
                </div>
                <div class="input-box input-box-big">
                    <p>是否增刊：</p>
                    <a-select class="input" allowClear v-model="info.supplementCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in sfzkArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box input-box-big">
                    <p>属名机构：</p>
                    <a-textarea class="input" :rows="3" v-model="info.signatureAgency" :disabled="type=='look'" allowClear/>
                    <span class="input-tips">*论文中所有的作者机构信息</span>
                </div>
            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <a-button type="primary" icon="plus" @click="showInclude('添加收录情况','',-1)" v-if="type!='look'">新增</a-button>
                <h3>收录情况</h3>
                <p></p>
            </div>
            <a-table 
                :columns="includeColumns" 
                :data-source="info.collectList" 
                :pagination="false"
                bordered>
                <template slot="collectDbCode" slot-scope="text,record">
                    <a-select class="show-input" allowClear v-model="record.collectDbCode">
                        <a-select-option v-for="(item,index) in slsjkArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </template>
                <template slot="id" slot-scope="text,record">
                    <a class="action-btn" @click="showInclude('修改收录情况',record,1)">编辑</a>
                    <a-divider type="vertical"/>
                    <a class="action-btn" @click="info.collectList.splice(info.collectList.indexOf(record),1)">删除</a>
                </template>
            </a-table>
            <p class="table-tips">*如无收录号无需添加，由系统自动抓取。</p>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>论文信息</h3>
                <p></p>
            </div>
            <div class="info-main">      
                <div class="input-box" v-if="info.paperTypeCode=='QKLW'">
                    <p>是否增刊：</p>
                    <a-select class="input" allowClear v-model="info.supplementCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in sfzkArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                    <span class="input-tips">*不确定时可以不选择</span>
                </div>
                <div class="input-box" :class="info.paperTypeCode=='QKLW'?'':'input-box-big'">
                    <p>全文或长篇转载：</p>
                    <a-select 
                        class="input" 
                        show-search
                        :filter-option="filterOption"
                        @search="value=>{if(value!='')info.reprintTypeCode=value}"
                        allowClear 
                        v-model="info.reprintTypeCode" 
                        :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in qpzzArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                    <span class="input-tips">*请选择（或手动输入）</span>
                </div>
                <div class="input-box input-box-big">
                    <p>关键词：</p>
                    <a-input class="input" v-model="info.keywords" :disabled="type=='look'" allowClear />
                    <span class="input-tips">*多个关键词以；分隔</span>
                </div>
                <div class="input-box input-box-big">
                    <p>摘要：</p>
                    <a-textarea class="input" :rows="3" v-model="info.paperAbstract" :disabled="type=='look'" allowClear/>
                </div>
                <div class="input-box input-box-big">
                    <p>基金：</p>
                    <a-textarea class="input" :rows="3" v-model="info.paperFund" :disabled="type=='look'" allowClear/>
                </div>
                <div class="input-box input-box-big">
                    <p>原文链接：</p>
                    <a-input class="input" v-model="info.originalLink" :disabled="type=='look'" allowClear />
                </div>
                <div class="input-box">
                    <p>DOI：</p>
                    <a-input class="input" v-model="info.paperDoi" :disabled="type=='look'" allowClear />
                    <span class="input-tips">*用于准确匹配收录情况。链接前缀(http://dx.doi.org/)不要填写，正确格式如：10.1155/2016/3258494</span>
                </div>
                <div class="input-box">
                    <p>总字数：</p>
                    <a-input class="input" v-model="info.wordNumber" :disabled="type=='look'" allowClear />
                </div>
                <div class="input-box input-box-big">
                    <p>全文访问策略：</p>
                    <a-radio-group  class="input" v-model="info.accessPolicyType" :disabled="type=='look'">
                        <a-radio :value="1">公开</a-radio>
                        <a-radio :value="2">成果拥有者</a-radio>
                    </a-radio-group>
                </div>

            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>论文扫描件</h3>
                <p></p>
            </div>
            <a-upload-dragger
                class="upload-box"
                name="file"
                list-type="picture-card"
                :multiple="true"
                :action="$store.state.axiosUrl+'/api-f/files'"
                :headers="headers"
                @change="fileChange"
                :file-list="fileList"
                :disabled="type=='look'"
            >
                <p class="ant-upload-drag-icon">
                    <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text">点击或拖拽文件上传</p>
                <p class="ant-upload-hint">支持单次或批量上传</p>
            </a-upload-dragger>
        </div>
        <div class="btn-box">
            <a-button @click="$router.go(-1)">取消</a-button>
            <a-button type="primary" v-if="type!='look'" @click="sub(1)">暂存</a-button>
            <a-button type="primary" v-if="type!='look'" @click="sub(2)">提交</a-button>
        </div>
        <a-modal
            :title="authorTitle"
            :visible="authorShow"
            @ok="authorOk"
            width="40%"
            @cancel="authorShow=false"
        >
            <div class="input-box input-box-big">
                <p><span>*</span>作者：</p>
                <a-select 
                    class="input" 
                    allowClear
                    show-search
                    :filter-option="filterOption"
                    @search="teacherSearch"
                    v-model="authorObj.authorName"
                    @change="teacherChange"
                    option-label-prop="label">
                    <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherName" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
                </a-select>
                <!-- <a-input class="input" v-model="authorObj.authorName" allowClear/> -->
                <span class="input-tips">每次只能添加一名作者，拼写同原文，即中文发表论文填中文拼写，外文发表论文填外文拼写</span>
            </div>
            <div class="input-box input-box-big">
                <p>院系：</p>
                <a-input class="input" v-model="authorObj.departmentName"/>
            </div>
            <div class="input-box input-box-big">
                <p>通讯作者：</p>
                <a-radio-group  class="input" v-model="authorObj.isCorrespond">
                    <a-radio :value="true">是</a-radio>
                    <a-radio :value="false">否</a-radio>
                </a-radio-group>
            </div>
            <div class="input-box input-box-big">
                <p>所有作者排名：</p>
                <a-input-number class="input" v-model="authorObj.sortNo"/>
            </div>
            <div class="input-box input-box-big">
                <p>成员类型：</p>
                <a-radio-group  class="input" v-model="authorObj.memberType">
                    <a-radio :value="1">本机构成员</a-radio>
                    <a-radio :value="0">非本机构成员</a-radio>
                </a-radio-group>
                <span class="input-tips input-tips-color">作者为上海大学机构成员请勾选本机构成员</span>
            </div>
            <div class="input-box input-box-big">
                <p>署名单位：</p>
                <a-textarea class="input" :rows="4" v-model="authorObj.signatureUnit"/>
                <span class="input-tips">内容同原文中对应的作者署名单位的所有原始信息，包含机构，部门和地址，邮编等，如果原文中没有署名信息可自行填写。</span>
            </div>
        </a-modal>
        <a-modal
            :title="includeTitle"
            :visible="includeShow"
            @ok="includeOk"
            width="30%"
            @cancel="includeShow=false"
        >
            <div class="input-box input-box-big">
                <p><span>*</span>收录数据库：</p>
                <a-select class="input" allowClear v-model="includeObj.collectDbCode" :disabled="type=='look'">
                    <a-select-option v-for="(item,index) in slsjkArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </div>
            <div class="input-box input-box-big">
                <p>收录号：</p>
                <a-input class="input" v-model="includeObj.collectNumber"/>
            </div>
        </a-modal>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/research/thesis'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                type:'',
                zpType:'',
                authorColumns:[],
                authorTitle:'',
                authorShow:false,
                authorNum:-1,
                authorObj:{},
                includeColumns:[],
                includeTitle:'',
                includeShow:false,
                includeNum:-1,
                includeObj:{},
                info:{
                    paperTypeCode:null,
                    classCode:null,
                    languageCode:null,
                    title:null,
                    foreignTitle:null,
                    journalName:null,
                    issn:null,
                    publicationYear:null,
                    publishVolume:null,
                    publishStage:null,
                    publishPage:null,
                    signatureAgency:null,
                    supplementCode:null,
                    reprintTypeCode:null,
                    keywords:[],
                    paperAbstract:null,
                    paperFund:null,
                    paperDoi:null,
                    originalLink:null,
                    accessPolicyType:null,
                    conferencePlace:null,
                    conferenceStartDate:null,
                    conferenceEndDate:null,
                    conferenceOrganizer:null,
                    conferenceName:null,
                    majorAchievement:[],
                    achievementSubject:null,
                    influenceFactor:null,
                    jcrPartition:null,
                    casPartition:null,
                    authorList:[],
                    collectList:[],
                    fileList:[],
                    approvalStatus:null,
                    publishPlace:null,
                    wordNumber:null,
                },
                majorAchievement:[],
                lwcgArr:[],
                zpflArr:[],
                lwyyArr:[],
                xyArr:[],
                sfzkArr:[],
                dataopen: false,
                slsjkArr:[],
                qpzzArr:[],
                headers:{
                    'Authorization':'Bearer '+ this.$store.state.access_token
                },
                fileList:[],
                jsArr:[],
            }
        },
        mounted () {
            this.type=this.$route.query.type;
            getDicts({dataCode:'LWCGLX',status:true}).then(res=>{
                this.lwcgArr=res.data.dicts;
                this.info.paperTypeCode=res.data.defaultValue[0]
            })
            getDicts({dataCode:'LWZPFL',status:true}).then(res=>{
                this.zpflArr=res.data.dicts;
                this.info.classCode=res.data.defaultValue[0]
            })
            getDicts({dataCode:'LWYY',status:true}).then(res=>{
                this.lwyyArr=res.data.dicts;
                this.info.languageCode=res.data.defaultValue[0]
            })
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xyArr=res.data.dicts;
            })
            getDicts({dataCode:'SFZK',status:true}).then(res=>{
                this.sfzkArr=res.data.dicts;
                this.info.supplementCode=res.data.defaultValue[0]
            })
            getDicts({dataCode:'LWSLSJK',status:true}).then(res=>{
                this.slsjkArr=res.data.dicts;
            })
            getDicts({dataCode:'QWHZZ',status:true}).then(res=>{
                this.qpzzArr=res.data.dicts;
                this.info.reprintTypeCode=res.data.defaultValue[0]
            })
            getTeacher().then(res=>{
                this.jsArr=res.data;
            })

            if(this.type!='add'){
                info(this.$route.query.id).then(res=>{
                    this.info=res.data;
                    this.fileList=[];
                    for(let i=0;i<this.info.fileList.length;i++){
                        this.fileList.push({
                            uid: this.info.fileList[i].id,
                            name: this.info.fileList[i].fileName,
                            status: 'done',
                            url: this.$store.state.axiosUrl+this.info.fileList[i].fileUrl,
                        })
                    }
                    this.majorAchievement=this.info.majorAchievement.split(';')

                })
            }
            this.authorColumns = [
                {
                    title: '作者',
                    dataIndex: 'authorName',
                    align:'center'
                },
                {
                    title: '院系',
                    dataIndex: 'departmentName',
                    align:'center',
                },
                {
                    title: '通讯作者',
                    dataIndex: 'isCorrespond',
                    align:'center',
                    scopedSlots: { customRender: 'isCorrespond' }
                },
                {
                    title: '所有作者排名',
                    dataIndex: 'sortNo',
                    align:'center'
                },
                {
                    title: '成员类型',
                    dataIndex: 'memberType',
                    align:'center',
                    scopedSlots: { customRender: 'memberType' }
                },
                {
                    title: '署名单位',
                    dataIndex: 'signatureUnit',
                    align:'center'
                },
            ];
            this.includeColumns = [
                {
                    title: '序号',
                    align:'center',
                    customRender: (text, row, index) => {
                        return index+1;
                    },
                },
                {
                    title: '收录数据库',
                    dataIndex: 'collectDbCode',
                    align:'center',
                    scopedSlots: { customRender: 'collectDbCode' }
                },
                {
                    title: '收录号',
                    dataIndex: 'collectNumber',
                    align:'center'
                },
            ];
            if(this.type!='look'){
                var obj={
                    title: '操作',
                    width:300,
                    scopedSlots: { customRender: 'id' }
                }
                this.authorColumns.push(obj)
                this.includeColumns.push(obj)
            }
        },
        methods:{
            showAuthor(title,obj,num){
                if(obj==''){
                    this.authorObj={
                        authorNo:'',
                        authorName:'',
                        departmentCode:'',
                        departmentName:'',
                        isCorrespond:false,
                        sortNo:'',
                        memberType:1,
                        signatureUnit:'',
                    };
                    this.authorNum=-1
                }else{
                    this.authorObj=obj
                    this.authorNum=num
                }
                this.authorTitle=title;
                this.authorShow=true;
            },
            authorOk(){
                if(this.authorNum==-1){
                    this.info.authorList.push(this.deepCopy(this.authorObj))
                }
                this.authorShow=false;
            },
            // 点击选择框事件 弹出日期组件选择年
            openChangeYear(status) {
                if (status) {
                    this.dataopen = true;
                } else {
                    this.dataopen = false;
                }
            },
            // 选择年之后 关闭弹框
            panelChangeYear(value){
                this.info.publicationYear = this.getTimeStr(value._d,'yyyy') ;
                this.dataopen = false;
            },
            showInclude(title,obj,num){
                if(obj==''){
                    this.includeObj={
                        collectDbCode:'',
                        collectNumber:'',
                    };
                    this.includeNum=-1
                }else{
                    this.includeObj=obj
                    this.includeNum=num
                }
                this.includeTitle=title;
                this.includeShow=true;
            },
            includeOk(){
                if(this.includeNum==-1){
                    this.info.collectList.push(this.deepCopy(this.includeObj))
                }
                this.includeShow=false;
            },
            fileChange(file){
                if(typeof file.file.response!='undefined'){
                    var res=file.file.response;
                    this.$notification['success']({
                        message: '成功',
                        description:'文件上传成功'
                    });
                    this.info.fileList.push({
                        fileName:res.name,
                        fileUrl:res.url
                    })
                }else if(file.file.status=='removed'){
                    var num=this.fileList.indexOf(file.file);
                    this.info.fileList.splice(num, 1)
                }
                this.fileList=file.fileList;
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(text){
                var isSub=true;
                var arr=[];
                if(this.info.paperTypeCode=='QKLW'){
                    arr=['title','journalName','issn','publicationYear']
                }else if(this.info.paperTypeCode=='HYLW'){
                    arr=['title','journalName','conferencePlace','conferenceName','publicationYear','publishPage']
                }
                for(let i=0;i<arr.length;i++){
                    if(this.info[arr[i]]==null||this.info[arr[i]]===''){
                        isSub=false;
                        break;
                    }
                }
                if(isSub){
                    this.info.majorAchievement=this.majorAchievement.join(';')
                    this.info.approvalStatus=text;
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增本科论文成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改本科论文成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
            teacherChange(value){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherName==value){
                        this.authorObj.authorNo=this.jsArr[i].teacherId;
                        this.authorObj.departmentCode=this.jsArr[i].orgCode;
                        this.authorObj.departmentName=this.jsArr[i].orgName;
                    }
                }
            },
            teacherSearch(value){
                if(value!=''){
                    this.authorObj.authorName=value;
                    this.authorObj.authorNo='';
                }

            }

        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .input-box{
        width: 50%;
        display: flex;
        flex-wrap: wrap;
        line-height: 32px;
        margin-bottom: 1.5rem;
    }
    .input-box-big{
        width: 100%;
    }
    .input-box p{
        width: 12rem;
        text-align: right;
        font-weight: bolder;
    }
    .input-box p span{
        display: inline-block;
        color: #ff0000;
        font-weight: bold;
        font-size: 1.1rem;
        vertical-align: middle;
        margin-right: 5px;
    }
    .input-box .input{
        width: calc(100% - 14rem);
    }
    .input-box .input.ant-input-affix-wrapper{
        height: 34px;
    }
    .input-box .input.ant-input-affix-wrapper-textarea-with-clear-btn{
        height: auto;
    }
    .input-box .time-ac >>> .ant-calendar-picker-icon{
        top: 30%;
    }
    .table-tips,
    .input-box .input-tips{
        display: block;
        margin-left: 12rem;
        font-size: 13px;
        line-height: 20px;
    }
    .input-box .input-tips-color{
        color: #ff0000;
    }

    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
        padding-bottom: 1rem;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .upload-box{
        margin-top: 2rem;
        display: block;
    }
    .ant-radio-wrapper{
        vertical-align: sub;
    }
    .table-tips{
        margin: 0;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .upload-box >>> .ant-upload-list:after{
      content: ".";
      display: block;
      font-size: 0;
      height: 0;
      clear: both;
    }
    .upload-box >>> .ant-upload.ant-upload-disabled{
        display: none;
    }
    .input >>> .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled,.ant-calendar-picker >>> .ant-input[disabled]{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .upload-box >>> .ant-upload-list:after{
      content: ".";
      display: block;
      font-size: 0;
      height: 0;
      clear: both;
    }
    .upload-box >>> .ant-upload.ant-upload-disabled{
        display: none;
    }

</style>
